import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties } from 'react';

// gloss
type SortableItemHandle = {
  setNodeRef: (node: HTMLElement | null) => void;
  style: CSSProperties;
  isDragging: boolean;
  handleRef: (node: HTMLElement | null) => void;
  handleProps: Record<string, unknown>;
  listeners: Record<string, unknown>;
};

// gloss
export const useSortableItem = (id: string): SortableItemHandle => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  return {
    setNodeRef,
    style: {
      transform: CSS.Transform.toString(transform),
      transition,
      zIndex: isDragging ? 10 : undefined,
    },
    isDragging,
    handleRef: setActivatorNodeRef,
    handleProps: { ...attributes, ...listeners },
    listeners: { ...(listeners ?? {}) },
  };
};
